<template>
    <div>
        <button @click="open = true"
            class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
        >
            {{modalTitle}}
        </button>

        <div
            v-cloak
        >
            <div
                v-bind:id="id"
                class="modal"
                v-show="open"
            >
                <div class="modal-overlay"></div>

                <div class="modal-container" :style="'margin-left:' + ($root.mainWidth/2 - 50) + 'px;'">
                    <div class="modal-content">
                        <div class="modal-heading">
                            <h1>{{modalTitle}}</h1>

                            <div class="modal-close cursor-pointer z-50 block" @click="open = false">
                                <svg class="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                                <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
                                </svg>
                            </div>
                        </div>

                        <div class="modal-body">
                            {{modalBody}}
                        </div>

                        <div class="modal-footer">
                            <button
                                class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                @click="confirm"
                            >
                                Delete
                            </button>

                            <button class="ml-3 bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                @click="open = false"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['id', 'title', 'body'],

        data() {
            return {
                open: false,
            }
        },

        computed: {
            modalTitle() {
                return this.title
                    ? this.title
                    : 'Delete'
            },

            modalBody() {
                return this.body
                    ? this.body
                    : 'Are you sure that you want to delete this?'
            }
        },

        methods: {
            confirm() {
                this.open = false;
                this.$parent.delete();
            },
        }
    }
</script>
